Alerts = require 'app/scripts/views/lib/alerts'
ApiError = require 'app/scripts/network/api-error'
ApiPromise = require 'app/scripts/network/api-promise'
Auth = require 'app/scripts/db/auth'
{ getOrganizationBillingUrl } = require 'app/scripts/controller/urls'
PopOver = require 'app/scripts/views/lib/pop-over'
React = require 'react'
localizeServerError = require 'app/scripts/lib/localize-server-error'
{ maybeDisplayOrgMemberLimitsError } = require 'app/scripts/views/organization/member-limits-error'
t = require('app/scripts/views/internal/recup-with-helpers')('manage_members')
{ track, trackUe } = require '@trello/analytics'
_ = require 'underscore'
l = require 'app/scripts/lib/localize'
OrgFeatures = require('@trello/product-features').OrganizationFeatures
{ formatMoney } = require 'app/scripts/lib/format/money'
{ useNonPublicIfAvailable } = require 'app/common/lib/util/non-public-fields-filter'
{ UpgradePromptFullConnected: UpgradePromptFull } = require 'app/src/components/UpgradePrompts/UpgradePromptFull'
{ IconName } = require 'app/common/components/controls'
{ isDesktop } = require '@trello/browser'
BulkAddOrgMembersView = require 'app/scripts/views/organization/bulk-add-org-members-view-react'
InvitationLink = require './invitation-link'
LinkGoogleApps = require './link-google-apps'
InviteAddName = require './invite-add-name'
MemberList = require './member-list'
Summary = require './summary'
{ siteDomain, dontUpsell } = require '@trello/config'

DEBOUNCE_DELAY = 250 #ms
debounce = (fn) -> _.debounce(fn, DEBOUNCE_DELAY)
EMAIL_REGEX = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/

module.exports = class extends React.Component
  displayName: 'ManageOrgMembersComponent'

  constructor: (props) ->
    super(props)

    @state = {
      isSearching: false
      members: null
      searchValue: null
      selectedMembers: []
    }

    { model } = @props

  render: t.renderable ->
    { isSearching, members, searchValue, selectedMembers } = @state
    { model } = @props

    showBillingSummary = model.isBusinessClass() && !model.isPO()
    showBCPrompt = !model.isPremium()
    searchClass = if isSearching then '' else '.hide'
    isEmail = searchValue && EMAIL_REGEX.test(searchValue) && Auth.me().get('email') != searchValue

    product = model.getProduct()

    placeholder = l('add member placeholder')
    isPerUser = OrgFeatures.isPerUser(product)
    perUserPrice = formatMoney(OrgFeatures.getPrice(product))
    isYearly = OrgFeatures.getInterval(product) == 'yearly'
    isMonthly = OrgFeatures.getInterval(product) == 'monthly'
    canLinkGoogleApps = model.isFeatureEnabled('googleApps') && (!model.get('prefs').associatedDomain || @googleAppsFetchFailed) && model.editable()

    t.div '.add-member-popup.team-members-tab-layout', =>
      t.div '.manage-member-invitation-section', =>
        t.div '.search-with-spinner', =>
          t.h4 ->
            t.icon 'member', 'enter-email-address-or-name'
          t.input '.search-member.js-autofocus', { type: 'text', placeholder, onChange: @onSearchInputChange }
          t.div ".spinner.small#{searchClass}"
          t.p '.u-bottom.quiet.bulk-add-members-copy', =>
            t.format 'big-team'
            t.a '.u-bottom.action-link', { href: '#', onClick: @showBulkAddView }, ->
              t.format 'add-many-people-at-once'

      if members
        if !members.length
          if isEmail
            @renderInviteAddName()
          else
            t.div '.quiet.search-text.no-results', -> t.format 'no-results'
        else
          @renderMemberList()

      if isPerUser && model.get('paidAccount')?.userCountBilledThisPeriod <= model.memberList.length
        t.p '.quiet.u-bottom.per-user', ->
          if isMonthly
            t.format 'business-class-pricing-is-per-user-adding-a-member-will-increase-the-price-by-jpsprice-per-month', { jpsPrice: perUserPrice }
          if isYearly
            t.format 'business-class-pricing-is-per-user-adding-a-member-will-increase-the-price-by-jpsprice-per-year', { jpsPrice: perUserPrice }

      @renderInvitationLink()

      t.div '.js-ad'

      if canLinkGoogleApps
        @renderLinkGoogleApps()

      if showBCPrompt
        if model.get('allAdminsEnabled')
          @renderAllAdminsEnabledBCPrompt()
        else
          @renderBCPrompt()

      if showBillingSummary && selectedMembers.length
        @renderSummary()
      else
        @renderAddButton()

  renderMemberList: =>
    { members, selectedMembers } = @state

    t.createElement MemberList, { members, selectedMembers, @toggleMember }

  renderInvitationLink: =>
    { model } = @props

    teamUrl = "#{siteDomain}/#{model.get('name')}"
    t.createElement InvitationLink, { apiUrl: model.url(), teamUrl: teamUrl, teamId: model.get('id') }

  renderLinkGoogleApps: =>
    { model, modelCache } = @props
    showBillingSummary = model.isBusinessClass() && !model.isPO()

    t.createElement LinkGoogleApps, { model, modelCache, showBillingSummary }

  renderInviteAddName: =>
    { model, modelCache } = @props
    { searchValue } = @state

    email = searchValue

    t.createElement InviteAddName, { email, model, modelCache }

  renderAllAdminsEnabledBCPrompt: =>
    props =
      headline: l([
        'upgrade prompt',
        'team page',
        'invite-popover',
        if dontUpsell then 'headline-auaa-desktop' else 'headline-auaa-2'
      ])
      content: l([
        'upgrade prompt',
        'team page',
        'invite-popover',
        if dontUpsell then 'content-auaa-desktop' else 'content-auaa-2'
      ])
      cta: l(['upgrade prompt', 'learn more'])
      orgId: @props.model.id
      allowUpsell: true
      hidePlanOverlay: dontUpsell
      ctaLink: if dontUpsell then '/business-class' else getOrganizationBillingUrl(@props.model)
      source: 'inviteToTeamInlineDialog'
      ctaOnClick: => trackUe(
        'team page',
        'opens',
        'team page bc tab',
        '',
        '',
        'by clicking full upgrade prompt in team page invite members popover',
        { allAdminsEnabled: true },
      )
      iconName: IconName.BusinessClass

    t.div '.bc-prompt-invite-popover', ->
      t.createElement UpgradePromptFull, props

  renderBCPrompt: =>
    props =
      headline: l(['upgrade prompt', 'team page', 'invite-popover', 'headline'])
      content: l(['upgrade prompt', 'team page', 'invite-popover', 'content'])
      cta: l(['upgrade prompt', 'learn more'])
      orgId: @props.model.id
      ctaLink: getOrganizationBillingUrl(@props.model)
      source: 'inviteToTeamInlineDialog'
      ctaOnClick: => trackUe(
        'team page',
        'opens',
        'team page bc tab',
        '',
        '',
        'by clicking full upgrade prompt in team page invite members popover'
      )
      iconName: IconName.Member

    t.div '.bc-prompt-invite-popover', ->
      t.createElement UpgradePromptFull, props


  renderAddButton: =>
    { selectedMembers } = @state

    selectedMembersCount = selectedMembers.length
    addToTeamButtonClass = if selectedMembersCount then '' else '.disabled'

    t.button ".primary.full#{addToTeamButtonClass}",
      { onClick: @addSelectedMembers, disabled: !selectedMembersCount },
      -> t.format 'add-to-team'

  renderSummary: =>
    { selectedMembers } = @state
    { model } = @props

    selectedMembersCount = selectedMembers.length
    price = model.calculateTotalPrice selectedMembersCount

    if model.isPremiumMonthly()
      subscriptionIntervalKey = 'monthly-subscription'
    if model.isPremiumYearly()
      subscriptionIntervalKey = 'yearly-subscription'

    salesTaxForSubscriberUrl = "#{model.urlRoot}/#{model.id}/paidAccount/salesTaxForSubscriber"

    t.createElement Summary, { @addSelectedMembers, price, salesTaxForSubscriberUrl, selectedMembersCount, subscriptionIntervalKey }

  toggleMember: (idMember) =>
    if @state.selectedMembers.some((id) -> id == idMember)
      selectedMembers = @state.selectedMembers.filter((id) -> id != idMember)
    else
      selectedMembers = [@state.selectedMembers..., idMember]

    @setState { selectedMembers }

  onSearchInputChange: ({ target: { value } }) =>
    @setState selectedMembers: []

    if !value.length
      @setState({ members: null, searchValue: null })
    else
      @searchMembers value

  searchMembers: debounce (searchValue) ->
    searchValue = searchValue.toLowerCase().trim()

    @setState {
      isSearching: true
      searchValue
    }

    ApiPromise
      url: '/1/search/members/'
      type: 'get'
      data:
        idOrganization: @props.model.id
        query: searchValue
      dataType: 'json'
    .then (members) =>
      # if there is no id then it's not really a user it's for inviting a new user when entering an unknown email
      members = _.chain(members)
       .filter((member) -> member.id)
       .map((member) ->
          return _.extend(member, {
            avatarUrl: useNonPublicIfAvailable(member, 'avatarUrl'),
            fullName: useNonPublicIfAvailable(member, 'fullName'),
            initials: useNonPublicIfAvailable(member, 'initials')
          })
       )
       .sortBy((member) -> member.fullName?.toLocaleLowerCase())
       .value()

      @setState {
        isSearching: false
        members
      }

  addSelectedMembers: =>
    { members, selectedMembers } = @state
    { model, addMembersCallback } = @props

    if maybeDisplayOrgMemberLimitsError(@el, model, null)
      return

    selectedMembers.forEach (idMember) =>
      member = members.filter((m) -> m.id == idMember)[0]

      model.addMembers(member)
        .then(addMembersCallback || (->))
        .catch ApiError, @_handleError

    PopOver.hide()

  _handleError: (resOrApiError) =>
    message = localizeServerError(resOrApiError)

    Alerts.showLiteralText(message, 'error', 'alert', 3000)
    track("Invitations", "Error: #{ resOrApiError.message ? resOrApiError.responseText }")

  showBulkAddView: =>
    { model } = @props

    PopOver.toggle
      elem: @el
      getViewTitle: -> l ['view title', 'add members']
      reactElement: React.createElement BulkAddOrgMembersView, {
        key: 'bulk add members'
        model
      }
